import {API} from "../HttpHandler";
import config from "../../../config";

export const cancelToken = (bookingId) => {
  return API.put(
    `${config.endPoints.baseURL}/turnero/canceltoken/${bookingId}`
  );
};

export const getModuleByDeskId = (params) => {
  return API.get(`${config.endPoints.baseURL}/turnero/modules`, {
    params,
  });
};

export const getTotem = (totemId) => {
  return API.get(`${config.endPoints.baseURL}/turnero/totems/${totemId}/desks`);
};
